import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/driveManage',
        name: 'driveManage',
        component: resolve => require(['@/views/driveManage/index'], resolve),
        meta: {
          title: '驱动管理',
          breadLevel: 0,
          icon: 'icon-driven',
          auth: auth.drive
        }
      }
    ]
  }
]

export default routes
